import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { IdValueObject } from '../../../../utility/model/id-value-object.model';

export class FeedbackDeliveryId extends IdValueObject {
  static create(value: string): FeedbackDeliveryId {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new FeedbackDeliveryId(value);
  }
}
